import { useNavigate } from "react-router-dom";
import { Button } from "../../../../core/components/atoms/Button";
import { Typography } from "../../../../core/components/molecules/Typography";
import { Modal } from "../../../../core/components/templates/Modal";

interface IModalOnSuccess {
  action: () => void;
  isOpen: boolean;
  onClose: () => void;
}

export default function ModalOnSuccess({ action, isOpen, onClose }: IModalOnSuccess) {
  const navigate = useNavigate();
  
  return (
    <Modal
      isOpen={isOpen}
      onClose={() => onClose()}
      position="center"
      className="p-0 w-2/5"
    >
      <div className="flex flex-col gap-xl">
        <Typography weight="bold">
          Sua redação foi enviada para correção! ✅
        </Typography>
        <Typography>
        O prazo para você receber a correção da sua redação é de<b> 5 dias úteis</b>.
        </Typography>
        <Typography>
          Se você enviar duas ou mais redações, as correções serão liberadas uma por vez. 
          Ou seja, se você enviou duas redações hoje, o primeiro texto será corrigido em até 5 
          dias úteis e, no segundo envio, os 5 dias úteis começarão a contar após a conclusão dos 
          5 dias úteis do envio anterior.
        </Typography>
        <Typography>
          Acompanhe suas redações enviadas e corrigidas na área de Redação {">"} Minhas redações.
        </Typography>
        <div className="flex flex-row items-center justify-end gap-sm">
          <Button variant="text" onClick={() => navigate('/redacoes/minhas_redacoes')}>
            Ir para minhas redações
          </Button>
          <Button variant="text" onClick={() => action()}>
            Finalizar
          </Button>
        </div>
      </div>
    </Modal>
  )
}